import { Box, SkeletonGroup, SkeletonRectangle } from '@wix/design-system';
import React from 'react';
import s from '../../common.scss';
import styles from './TldPromotionsList.scss';
const TldPromotionsListSkeletonItem = () => /*#__PURE__*/React.createElement(Box, {
  padding: "20px 24px",
  direction: "vertical",
  gap: "SP4",
  align: "space-between",
  position: "relative",
  className: styles.item
}, /*#__PURE__*/React.createElement(Box, {
  direction: "vertical",
  gap: "52px"
}, /*#__PURE__*/React.createElement(Box, {
  direction: "vertical",
  gap: "20px"
}, /*#__PURE__*/React.createElement(Box, {
  minHeight: "18px"
}, /*#__PURE__*/React.createElement(SkeletonRectangle, {
  className: s.skeleton,
  width: "80px",
  height: "14px"
})), /*#__PURE__*/React.createElement(SkeletonRectangle, {
  className: s.skeleton,
  width: "120px",
  height: "59px"
})), /*#__PURE__*/React.createElement(SkeletonRectangle, {
  className: s.skeleton,
  width: "160px",
  height: "16px"
})), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(SkeletonRectangle, {
  className: s.skeleton,
  width: "50px",
  height: "16px"
})));
export const TldPromotionsListSkeleton = _ref => {
  let _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? 8 : _ref$limit;
  return /*#__PURE__*/React.createElement(SkeletonGroup, {
    skin: "light"
  }, Array.from({
    length: limit
  }).map((_, index) => /*#__PURE__*/React.createElement(TldPromotionsListSkeletonItem, {
    key: index
  })));
};
//# sourceMappingURL=TldPromotionsListSkeleton.js.map